/* Fit the original catalogue images within their mobile frames; never repaint artwork. */
(() => {
  const mq=matchMedia('(max-width:749px)'), cache=new Map(), mounted=new WeakSet(), bounds=new WeakMap();
  const resize=new ResizeObserver(entries=>entries.forEach(({target})=>fit(target,bounds.get(target))));
  function box(image){
    try{
      const w=120,h=Math.max(1,Math.round(w*image.naturalHeight/image.naturalWidth));
      const canvas=document.createElement('canvas');canvas.width=w;canvas.height=h;
      const ctx=canvas.getContext('2d',{willReadFrequently:true});ctx.drawImage(image,0,0,w,h);
      const pixels=ctx.getImageData(0,0,w,h).data;let x0=w,y0=h,x1=0,y1=0;
      for(let y=0;y<h;y++)for(let x=0;x<w;x++){const n=(y*w+x)*4;if(pixels[n+3]>32&&pixels[n]+pixels[n+1]+pixels[n+2]<690){x0=Math.min(x0,x);y0=Math.min(y0,y);x1=Math.max(x1,x+1);y1=Math.max(y1,y+1)}}
      return x1>x0&&y1>y0?{x0:x0/w,y0:y0/h,x1:x1/w,y1:y1/h,a:image.naturalWidth/image.naturalHeight}:null;
    }catch{return null}
  }
  function fit(img,b){
    if(!mq.matches){img.style.transform='';return}if(!b)return;
    const W=img.clientWidth,H=img.clientHeight;if(!W||!H)return;
    const rw=Math.min(W,H*b.a),rh=rw/b.a;
    const scale=Math.min(3,W*.91/(rw*(b.x1-b.x0)),H*.86/(rh*(b.y1-b.y0)));
    const dx=rw*((b.x0+b.x1)/2-.5),dy=rh*((b.y0+b.y1)/2-.5);
    img.style.transform=`translate(${-dx*scale}px,${-dy*scale}px) scale(${scale})`;
  }
  function mount(img){
    if(mounted.has(img))return;mounted.add(img);
    function ready(){
      const src=img.currentSrc||img.src;if(!src)return;
      if(!cache.has(src))cache.set(src,new Promise(resolve=>{const probe=new Image();probe.crossOrigin='anonymous';probe.onload=()=>resolve(box(probe));probe.onerror=()=>resolve(null);probe.src=src}));
      cache.get(src).then(b=>{if(!img.isConnected)return;bounds.set(img,b);fit(img,b);resize.observe(img)});
    }
    if(img.complete&&img.naturalWidth)ready();else img.addEventListener('load',ready,{once:true});
  }
  function scan(){if(mq.matches)document.querySelectorAll('[data-vxm-fit]').forEach(mount)}
  scan();document.addEventListener('shopify:section:load',scan);mq.addEventListener('change',scan);
  const main=document.querySelector('main');
  if(main)new MutationObserver(records=>{
    for(const record of records)for(const node of record.removedNodes){if(node.nodeType!==1)continue;const images=[...(node.matches('[data-vxm-fit]')?[node]:[]),...node.querySelectorAll('[data-vxm-fit]')];images.forEach(img=>{resize.unobserve(img);mounted.delete(img)})}
    scan();
  }).observe(main,{childList:true,subtree:true});
})();

(() => {
  const selector='.jdgm-rev__body, .jdgm-rev__reply-content, .jdgm-review-card__body';
  const decode=value=>value.replace(/\\'9[12]/g,'’').replace(/\\'9[34]/g,'"').replace(/\\'96/g,'–').replace(/\\'97/g,'—');
  function clean(root){
    const walker=document.createTreeWalker(root,NodeFilter.SHOW_TEXT);let node;
    while((node=walker.nextNode())){const value=decode(node.nodeValue);if(value!==node.nodeValue)node.nodeValue=value}
  }
  document.querySelectorAll(selector).forEach(clean);
  let pending=false;
  new MutationObserver(records=>{
    if(!records.some(r=>(r.target.nodeType===1?r.target:r.target.parentElement)?.closest?.('[class*="jdgm"], [class*="jm-"]')||[...r.addedNodes].some(n=>n.nodeType===1&&(n.matches(selector)||n.querySelector(selector)))))return;
    if(pending)return;pending=true;requestAnimationFrame(()=>{pending=false;document.querySelectorAll(selector).forEach(clean)});
  }).observe(document.body,{childList:true,subtree:true,characterData:true});
})();
